/* SCRIPTS IMPORT CONTROL
Any custom built scripts from /custom or third - party library scripts from /lib must be listed here
This enables modular control of what is merged and minified, or deactivated if currently not needed.
*/

// Buttons
import { buttons } from './custom/custom';
buttons();

// Accordions
import { accordions } from './custom/custom';
accordions();

// Tabs Manager 
import { tabsManager } from './custom/custom';
tabsManager();

// Quickview
import { quickview } from './custom/custom';
quickview();

// Carousel
import { carousel } from './custom/custom';
carousel();

// Import CSS for build process
import '../css/styles.css';
